import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import styles from '../../styles/Header.module.css';
import { useAuth } from '../../common/Context/AuthContext';
import img from '../../assets/images/profile.png';
import SubmitButton from '../submitButton/SubmitButton';
import crediticon from '../../assets/images/crediticon.gif';
import { useStoreValues } from '../../common/Context/GlobalContext/GlobalStateProvider';
import CustomTooltip from '../customTooltip/CustomTooltip';
import { useAlert } from '../../common/Context/AlertContext';
import { refreshCredit } from '../../common/functions/creditRefresher/CreditRefresher';
import { useLoader } from '../../common/Context/LoaderContext';
import { HARDCODED_PRODUCTKEY } from '../../common/constant';
import { getInitials } from '../../common/Utils/Utils';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoader();
  const { setCreditData, creditData, fetchCreditDetails } = useStoreValues();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const { user, logout } = useAuth();

  // Check if current route is login or register
  const isAuthPage =
    location.pathname === '/login' || location.pathname === '/register';

  const handleProfileClick = () => {
    setShowDropdown((prev) => !prev);
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  useEffect(() => {
    if (user) {
      // fetchCreditDetails();
    } else {
      setShowDropdown(false);
    }
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [user]);

  const handleRefresh = (e) => {
    e.stopPropagation();
    refreshCredit({
      accountId: user?.accountId,
      fetchCreditDetails,
      showAlert,
      setLoading,
    });
  };

  return (
    <header className="navbar navbar-expand-lg navbar-light shadow-none">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img
            src="https://pixl.ai/assets/images/pixl_logo_black 1 (1).png"
            alt="Trial Platform"
            height="30"
            className="d-inline-block align-text-top me-2"
          />
          Trial <span className="text_master2">Platform</span>
        </Link>

        <button
          className="navbar-toggler collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto gap-4 me-lg-4 mb-2 mb-lg-0">
            {!user && !isAuthPage && (
              <>
                <li className="nav-item ">
                  <Link className="nav-link text-black" to="/">
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link text-black" to="/industries">
                    Industries
                  </Link>
                </li>
              </>
            )}
            {!user && !isAuthPage && (
              <li className="nav-item">
                <Link className="nav-link text-black" to="/products">
                  Products
                </Link>
              </li>
            )}
            {/* <li className="nav-item">
              <Link className="nav-link" to="/insights">Insights</Link>
            </li> */}
            {!user && !isAuthPage && (
              <li className="nav-item">
                <Link className="nav-link text-black" to="/about">
                  About
                </Link>
              </li>
            )}
          </ul>
          {user ? (
            <div
              style={{
                position: 'relative',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
              className={styles.profileWrapper}
              ref={dropdownRef}
            >
              <div
                className="headerSectionDetails"
                onClick={handleProfileClick}
              >
                <div className="bg_master d-flex rounded-circle w_40x h_40x me-2">
                  <span className="font_16 fw_500 m-auto text-white">
                    {getInitials(user?.name)}
                  </span>
                </div>
                <div className={styles.profileInfo}>
                  <p className={styles.userName}>{user?.name}</p>
                  <p
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    className={styles.credits}
                  >
                    <span className="font_12 font_400 me-1">Credits</span>{' '}
                    <div className="font_13 me-1">
                      {creditData?.remainingCredits ?? 0}{' '}
                    </div>
                    <img
                      className="w_14x h_14xobject-fit-contain"
                      src={crediticon}
                    />
                    <CustomTooltip content="Refresh to view latest credit balance">
                      <div onClick={(e) => handleRefresh(e)}>
                        <i class="fas fa-sync-alt font_11 ms-1"></i>
                      </div>
                    </CustomTooltip>
                  </p>
                </div>
              </div>
              <div>
                {/* for mobile View */}
                <a
                  onClick={() =>
                    (window.location.href = `${window.baseUrl}/login?productKey=${HARDCODED_PRODUCTKEY}`)
                  }
                  className="align-items-baseline br_7 d-flex d-lg-none text-black text-decoration-none font_600 mb-2 py-1"
                >
                  <i className="fas fa-user me-2 text-black"></i> Accounts
                </a>
                <button
                  onClick={handleLogout}
                  className="logoutBtn font_600 d-lg-none"
                >
                  <i className="fas fa-sign-out-alt me-2 text-black"></i> Logout
                </button>
              </div>
              {/* for System View */}
              {showDropdown && (
                <div className="dropdownMenu d-none d-lg-block px-2 py-2">
                  <div
                    onClick={() =>
                      (window.location.href = `${window.baseUrl}/login?productKey=${HARDCODED_PRODUCTKEY}`)
                    }
                    className="px-3 py-2 br_7 dropDownList font_600"
                  >
                    <i className="fas fa-user me-2 text-black"></i> Accounts
                  </div>
                  <div
                    onClick={handleLogout}
                    className="px-3 py-2 br_7 dropDownList font_600"
                  >
                    <i className="fas fa-sign-out-alt me-2 text-black"></i>{' '}
                    Logout
                  </div>
                </div>
              )}
            </div>
          ) : (
            !isAuthPage && (
              <ul className="navbar-nav gap-2">
                <li className="nav-item mb-2 mb-lg-0">
                  <SubmitButton
                    style={{ marginTop: '0px' }}
                    className="mt-0 rounded-pill"
                    onClick={() => navigate('/login')}
                    label="Login"
                  />
                </li>
                <li className="nav-item">
                  <SubmitButton
                    style={{ marginTop: '0px' }}
                    className="mt-0 rounded-pill btn-master-line"
                    onClick={() => navigate('/register')}
                    label="Register"
                  />
                </li>
              </ul>
            )
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
